var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoEditing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_191_1",
    "data-name": "Composant 191 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.119,
    height: 48.63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11579",
    "data-name": "Trac\\xE9 11579",
    className: "cls-1",
    d: "M145.624 89.885a1.421 1.421 0 0 1 0 2.46l-11.353 7.38A1.548 1.548 0 0 1 132 98.4V83.83a1.412 1.412 0 0 1 2.271-1.135zm-10.6 5.866 7-4.541-7-4.541z",
    transform: "translate(-107.022 -66.8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11580",
    "data-name": "Trac\\xE9 11580",
    className: "cls-1",
    d: "M59.605 0a1.492 1.492 0 0 1 1.514 1.514v45.6a1.393 1.393 0 0 1-1.514 1.514H1.514A1.492 1.492 0 0 1 0 47.116V1.514A1.628 1.628 0 0 1 1.514 0zm-49.2 22.9v-8.519H3.028V22.9zm-7.38 3.028v8.326h7.38v-8.331zM13.435 45.6h34.249V3.028H13.435zm44.656-22.7v-8.519h-7.38V22.9zm-7.38 3.028v8.326h7.38v-8.331zm7.38-22.9h-7.38v8.326h7.38zm-55.064 0v8.326h7.38V3.028zm0 42.575h7.38v-8.326H3.028zm55.064 0v-8.326h-7.38V45.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEditing);
export default __webpack_public_path__ + "static/media/videoEditing.098afbb323d381cd55fdb955616561ac.svg";
export { ForwardRef as ReactComponent };